import { createLazyComponent } from '../shared/createLazyComponent';

// Async import failure (chunk 404 / network flake, exhausted retries, or a missing
// export) would otherwise be an unhandled rejection no React error boundary can
// see, so `rethrowOnError` re-throws during render for the parent ErrorBoundary.
export const LazyAssistantDataProvider = createLazyComponent(
  () => import('./AssistantDataProvider'),
  'AssistantDataProvider',
  { label: 'Assistant Data Provider', rethrowOnError: true },
);
